import axios from 'axios';
import URL_CONST from '../../../config/url';
import {getHeaders} from '../../../store/dataService';
import {VideoRegionProps} from '../../../types/dataset/DatasetBinary';
import {BinaryStrategy, BinaryStrategyTypes} from './BinaryStrategyDto';
import {ExternalSegment} from '../DataReview/SegmentCreator/SegmentCreator';

export type ManualStrategyContext = {
  frameExtractionTimes: number[];
  segments: Array<ExternalSegment>;
  captureFramesEveryInSeconds: number;
};

export class ManualStrategy extends BinaryStrategy {
  private _regions: Partial<VideoRegionProps>[];
  private _captureFramesEveryInSeconds: ManualStrategyContext['captureFramesEveryInSeconds'];

  static STRATEGY_NAME: BinaryStrategyTypes = 'Manual';

  constructor({
    segments,
    frameExtractionTimes,
    captureFramesEveryInSeconds,
  }: ManualStrategyContext) {
    super(ManualStrategy.STRATEGY_NAME);

    this._captureFramesEveryInSeconds = captureFramesEveryInSeconds;
    this._regions = this.calculateRegions(frameExtractionTimes, segments);
  }

  private calculateRegions(
    frameExtractionTimes: number[] = [],
    segments: ManualStrategyContext['segments']
  ) {
    let regions: Partial<VideoRegionProps>[] = [
      ...frameExtractionTimes.map(timeInSeconds => ({
        startOffsetSeconds: timeInSeconds,
      })),
    ];

    if (this._captureFramesEveryInSeconds > 0) {
      if (!segments.length) {
        regions.push({
          samplingInterval: this._captureFramesEveryInSeconds,
        });
      } else {
        regions.push(
          ...segments.map(({startInSeconds, endInSeconds}) => ({
            stopOffsetSeconds: endInSeconds,
            startOffsetSeconds: startInSeconds,
            samplingInterval: this._captureFramesEveryInSeconds,
          }))
        );
      }
    }

    return regions;
  }

  async generateImages(datasetId: string, binaryId: string) {
    if (!datasetId) {
      throw new Error('Dataset ID is required');
    }

    this.isGenerating = true;

    try {
      const headers = await getHeaders({
        'Request-Timeout': 3000,
      });
      const response = await axios.put(
        URL_CONST.DSS_DATASET_JOB,
        {
          type: 'VIDEO_SAMPLING',
          binaryId,
          regions: this._regions,
        },
        {
          params: {datasetId},
          headers,
        }
      );

      return response.data;
    } catch (error) {
      throw error;
    } finally {
      this.isGenerating = false;
    }
  }
}
